(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/register-new.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/register-new.js');
"use strict";


const UPDATE_REGISTER_INFORMATION = svs.ticket_partner.digitalTickets.actions.UPDATE_REGISTER_INFORMATION;
const _React = React,
  useContext = _React.useContext;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input,
  CompanyNameInput = _svs$ticket_partner$s.CompanyNameInput,
  OrgNrInput = _svs$ticket_partner$s.OrgNrInput,
  PhoneNrInput = _svs$ticket_partner$s.PhoneNrInput,
  ContactInput = _svs$ticket_partner$s.ContactInput,
  EmailInput = _svs$ticket_partner$s.EmailInput,
  CellPhoneNrInput = _svs$ticket_partner$s.CellPhoneNrInput;
const CONTACT_PERSON = svs.ticket_partner.sharedComponents.input.constants.names.CONTACT_PERSON;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.constants.TEXTS,
  HEADER_COMPANY = _svs$ticket_partner$d.HEADER_COMPANY,
  HEADER_CONTACT_PERSON = _svs$ticket_partner$d.HEADER_CONTACT_PERSON;
const RegisterNew = () => {
  const _useContext = useContext(svs.ticket_partner.DigitalTicketsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const handleOnChange = _ref => {
    let target = _ref.target;
    dispatch({
      type: UPDATE_REGISTER_INFORMATION,
      payload: {
        field: target.id,
        value: target.value
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(GridRow, null, React.createElement("h2", null, HEADER_COMPANY)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(CompanyNameInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(OrgNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(PhoneNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  }))), React.createElement(GridRow, null, React.createElement("h2", null, HEADER_CONTACT_PERSON)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(ContactInput, {
    handleChange: handleOnChange,
    name: CONTACT_PERSON,
    state: state.registerNew,
    stateField: CONTACT_PERSON
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(EmailInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CellPhoneNrInput, {
    handleChange: handleOnChange,
    state: state.registerNew
  }))));
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.RegisterNew = RegisterNew;

 })(window);